import { getFiltersWithMultipleValues } from "../../../../study-plans/pages/StudyPlansV2/helpers"
import { FiltersState } from "../../../../../reporting/states"
import { TARGET_HIDDEN_FILTERS } from "../../../../study-plans/pages/StudyPlansV2/constants"

export const checkFiltersForMultipleValues = (
  state: FiltersState,
  currentTarget?: string
) => {
  return !!getFiltersWithMultipleValues(
    state,
    TARGET_HIDDEN_FILTERS[currentTarget]
  )?.length
}
